
class Tabs {
	constructor(selector) {
		this.tabsGlob = document.querySelectorAll(selector)
		if (this.tabsGlob.length > 0) {
			this.initTabs()
			this.tabRender()
		}
	}

	initTabs() {
		this.tabsGlob.forEach((tabsGlob) => {
			let count = 1
			const tabsBtn = tabsGlob.querySelectorAll('.js-tabs-btn')

			tabsBtn.forEach((tab) => {
				tab.setAttribute('tabindex', '0')
				tab.setAttribute('data-id', count++)

				tab.addEventListener('click', this.tabClick.bind(this))
				tab.addEventListener('keydown', (event) => {
					if (event.isComposing || event.keyCode === 32 || event.keyCode === 13)
						this.tabClick(event)
				})
			})
		})
	}

	tabRender() {
		const tabId = document.querySelector('.js-tabs-btn-active').dataset.id
		if (tabId) {
			this.tabSwith(tabId, false)
		}
	}

	tabClick(event) {
		const tabId = event.target.dataset.id

		this.tabSwith(tabId)
		this.titleSwith(event.target)
	}

	tabSwith(id, scrollToView = true) {
		this.tabsGlob.forEach((tabsGlob) => {

			const tabsBtn = tabsGlob.querySelectorAll('.js-tabs-btn')
			const tabsItem = tabsGlob.querySelectorAll('.js-tabs-item')

			tabsBtn.forEach((tab, i) => {
				tab.classList.remove('js-tabs-btn-active')
				tabsItem[i].classList.remove('js-tabs-item-active')
				tabsItem[i].style.maxHeight = 0
			})

			tabsBtn[id - 1].classList.add('js-tabs-btn-active')
			tabsItem[id - 1].classList.add('js-tabs-item-active')
			tabsItem[id - 1].style.maxHeight = `${tabsItem[id - 1].scrollHeight}px`
			if (scrollToView) {
				tabsBtn[id - 1].scrollIntoView({block: 'nearest', inline: 'start', behavior: 'smooth'})
			}
		})
	}

	titleSwith(el) {
		const title = document.querySelector('[data-title]')
		if (title) {
			title.textContent = el.textContent.trim()
		}
	}
}

window.addEventListener('DOMContentLoaded', new Tabs('.js-tabs'))
